import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'state/store';
import {
  mapBusinessDocuments,
  checkBusinessInfoSuccess,
  getMappedBusinessInfo,
} from './utils';

export const getRoot = (state: RootState) => state.businessInfo;
export const getProfileRoot = (state: RootState) => state.profile;

export const getIsFormUpdate = createSelector(
  [getRoot],
  ({ isFormUpdate }) => isFormUpdate,
);

export const getMappedBusinessDocuments = createSelector(
  [getRoot],
  ({ documents }) => mapBusinessDocuments(documents),
);

export const getShowDoingBusinessAs = createSelector(
  [getRoot],
  ({ showDoingBusinessAs }) => showDoingBusinessAs,
);

export const getLoadingProgress = createSelector(
  [getRoot],
  ({ loadingProgress }) => loadingProgress,
);

export const getApplicant = createSelector(
  [getRoot],
  ({ applicant }) => applicant,
);

export const getIdTypes = createSelector(
  [getRoot],
  ({ idTypes, idTypesCountryId, legalEntityTypes }) => {
    const idTypeOptions = idTypes
      .filter((type) => type.isActive && type.idDropdown)
      .map((type) => ({
        ...type,
        value: type.businessesDocumentsTypesId,
        name: type.description,
      }));
    const legalEntityOptions = legalEntityTypes.map((type) => ({
      ...type,
      name: type.description,
      value: type.businessesLegalEntityFormTypesId,
    }));

    return {
      idTypesCountryId,
      idTypes: idTypeOptions,
      legalEntityTypes: legalEntityOptions,
    };
  },
);

export const getIsSaving = createSelector(
  [getRoot],
  ({ isSaving }) => isSaving,
);

export const getIsBusinessInfoSuccess = createSelector(
  [getRoot, getProfileRoot],
  (
    { showDoingBusinessAs, documents },
    { business, businessAddress, businessTelephoneNumber },
  ) =>
    checkBusinessInfoSuccess({
      showDoingBusinessAs,
      documents,
      business,
      businessAddress,
      businessTelephoneNumber,
    }),
);

export const getBusinessInfo = createSelector(
  [getRoot, getProfileRoot],
  (businessInfo, profile) => getMappedBusinessInfo(businessInfo, profile),
);
